import { createFileRoute, redirect } from '@tanstack/react-router';

import { meQueryOptions } from '../../../api/me';

/**
 * Kept as a redirect, not deleted: `/me` is in menus, bookmarks and anything
 * anyone has pasted to a colleague. Its cards live on `/users/$oid` now, which
 * shows the same thing for whoever is reading.
 */
export const Route = createFileRoute('/_auth/me/')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.query({
      ...meQueryOptions(),
      staleTime: 'static',
    });
    throw redirect({ to: '/users/$oid', params: { oid: me.oid } });
  },
});
